import {POST} from "@/services/gateway";

const listSnapshotDetails = ({userIds, folderId, snapshotDateTime, pagination, searchTerm}) => {
  return POST('google/calendar/search', {userIds, folderId, snapshotDateTime, pagination, searchTerm})
}

const listBreadcrumps = ({userId, folderId, snapshotDate}) => {
  return POST('google/calendar/breadcrumbs', {userId, folderId, snapshotDate})
}


export {
  listSnapshotDetails,
  listBreadcrumps
}
